import { useMemo } from "react";
import RoutesComponent from "./Routes";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import { LanguageProvider, useLang } from "./context/LanguageContext";

// Emotion caches – one per direction, created once.
// stylis-plugin-rtl v2 wraps prefixer internally, so RTL cache only gets rtlPlugin.
// LTR cache still needs [prefixer] explicitly.
const rtlCache = createCache({ key: "muirtl", stylisPlugins: [rtlPlugin] });
const ltrCache = createCache({ key: "muiltr" });

const ThemedApp = () => {
    const { dir } = useLang();

    const theme = useMemo(
        () =>
            createTheme({
                direction: dir,
                typography: { fontFamily: "Arial" },
                palette: { mode: "light" },
            }),
        [dir],
    );

    return (
        <CacheProvider value={dir === "rtl" ? rtlCache : ltrCache}>
            <ThemeProvider theme={theme}>
                <RoutesComponent />
            </ThemeProvider>
        </CacheProvider>
    );
};

const App = () => (
    <LanguageProvider>
        <ThemedApp />
    </LanguageProvider>
);

export default App;
